var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoTham(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.0625,
    cy: 8.5625,
    r: 2.1875,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.71875,
    cy: 13.0312,
    r: 1.84375,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.375,
    cy: 16.8125,
    r: 1.5,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.03125,
    cy: 19.9062,
    r: 1.15625,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.6875,
    cy: 22.3125,
    r: 0.8125,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.125,
    cy: 22.3125,
    r: 0.8125,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0625,
    cy: 22.3125,
    r: 0.8125,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 22.3125,
    r: 0.8125,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.9375,
    cy: 22.3125,
    r: 0.8125,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.875,
    cy: 22.3125,
    r: 0.8125,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.8125,
    cy: 22.3125,
    r: 0.8125,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.75,
    cy: 22.3125,
    r: 0.8125,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.7812,
    cy: 19.9062,
    r: 1.15625,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.0312,
    cy: 19.9062,
    r: 1.15625,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.2812,
    cy: 19.9062,
    r: 1.15625,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.53125,
    cy: 19.9062,
    r: 1.15625,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.78125,
    cy: 19.9062,
    r: 1.15625,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4375,
    cy: 16.8125,
    r: 1.5,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16.8125,
    r: 1.5,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.25,
    cy: 16.8125,
    r: 1.5,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.8125,
    cy: 16.8125,
    r: 1.5,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0938,
    cy: 13.0312,
    r: 1.84375,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9688,
    cy: 13.0312,
    r: 1.84375,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.84375,
    cy: 13.0312,
    r: 1.84375,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5625,
    cy: 8.5625,
    r: 2.1875,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.75,
    cy: 8.5625,
    r: 2.1875,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.4062,
    cy: 3.40625,
    r: 2.53125,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.40625,
    cy: 3.40625,
    r: 2.53125,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.90625,
    cy: 3.40625,
    r: 2.53125,
    fill: "#4285F4",
    stroke: "white",
    strokeWidth: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoTham);
export default __webpack_public_path__ + "static/media/DoTham.5b66590e50f5a9bc1f2652b25c82049d.svg";
export { ForwardRef as ReactComponent };